var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfileFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.517 5.267C3.517 2.39206 5.86155 0 8.75 0C11.6311 0 13.983 2.35068 13.983 5.233C13.983 8.10794 11.6384 10.5 8.75 10.5C5.8689 10.5 3.517 8.14932 3.517 5.267ZM0 16.75C0 14.1358 2.13579 12 4.75 12H12.75C15.3642 12 17.5 14.1358 17.5 16.75V17.75C17.5 18.7142 16.7142 19.5 15.75 19.5H1.75C0.785786 19.5 0 18.7142 0 17.75V16.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileFilled);
export default __webpack_public_path__ + "static/media/user-profile-filled.4a4d2836f56d9e53550228acb7cf8d25.svg";
export { ForwardRef as ReactComponent };